<template>
  <Layout :page="'Chỉnh sửa tồn kho'" @submit="submit = $event">
    <div v-if="dataPermission.includes('NSH_INV_ITEM_BALANCE')">
      <ValidationObserver ref="observerItems">
        <b-form @submit.stop.prevent style="height: 100vh">
          <LayoutCard>

            <LayoutFieldSet>
              <LayoutField>
                <template #label>Chi nhánh</template>
                <template #input>
                  <BaseSelect
                    :getVmodel="locationName"
                    :options="dataLocations"
                    :hideRemove="true"
                    label="name"
                    placeholder="Chọn chi nhánh"
                    @select="getValueLocationName($event)"
                  />
                </template>
              </LayoutField>
              <LayoutField>
                <template #label>Kho</template>
                <template #input>
                  <BaseSelect
                    v-model="inventoryName"
                    :options="dataInventory"
                    :hideRemove="true"
                    label="name"
                    placeholder="Chọn kho"
                    @select="inventoryId = $event.coInventoryId"
                  />
                </template>
              </LayoutField>
            </LayoutFieldSet>
            
            <el-dropdown
              v-if="allowDisplayQuickActionInventory"
              trigger="click"
              placement="bottom-start"
            >
              <el-button type="secondary">
                Thao tác nhanh
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <popup-set-value :selected="selectedBox" type="changeQuantity" text="Thay đổi số lượng nhanh" @result="onResult"></popup-set-value>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <div style="max-width: 100%; width: 100%">
              <b-table
                :items="Inventory.lineItemReqs"
                :fields="fieldsInventory.filter(e => e.show)"
                :key="updateUI"
                >
                <template #head(edit)>
                  <i class="fa-solid fa-bars"></i>
                </template>
                <template v-slot:head(selected) v-if="itemUseImeiAndSerial">
                  <b-form-checkbox v-model="checkboxAll" @change="selectAll" />
                </template>
                <template v-slot:head(selected) v-else>
                  <span>STT</span>
                </template>
                <template
                  #cell(selected)="data"
                  v-if="itemUseImeiAndSerial"
                >
                  <b-form-checkbox
                    v-model="selectedBox"
                    :value="data.item"
                    @change="checkItem(data.item)"
                  />
                </template>
                <template
                  #cell(selected)="data"
                  v-else
                >
                  {{ data.item.key }}
                </template>
                <template #cell(edit)="data">
                  <div
                    class="btn-icon"
                    v-if="(dataPermission.includes('NSH_ITEM_PROD_UPDATE')
                      || dataPermission.includes('NSH_ITEM_PROD_CREATE'))"
                  >
                    <!-- thay đổi số lượng có emei/seria -->
                    <ChangeQuantity
                      :line-info="data.item"
                      v-if="Item.metaSearchable.statusImei"
                      @callback="data.item.quantity = $event"
                    />
                  </div>
                </template>

                <template #cell(name)="data">
                  {{ data.item.name === "" ? "Mặc định" : data.item.nameOption }}
                </template>

                <template #cell(reason)="data">
                  <BaseSelect
                    v-model="data.item.reason"
                    :disabled="
                      !dataPermission.includes('NSH_INV_ITEM_BALANCE') ||
                      Item.metaSearchable.statusImei
                    "
                    :options="listReason"
                    :label="'text'"
                    :hideRemove="true"
                    @select="
                      $event.text != ''
                        ? (data.item.reasonKey =
                            $event.key)
                        : (data.item.reasonKey = '')
                    "
                  />
                </template>

                <template #cell(adjusted)="data">
                  <BaseInput
                    placeholder="Nhập số lượng"
                    v-model="data.item.adjusted"
                    type="unit"
                    :validate="data.item.validate"
                    :disabled="
                      !dataPermission.includes('NSH_INV_ITEM_BALANCE') ||
                      Item.metaSearchable.statusImei
                    "
                    @blur="validateInventory()"
                  />
                </template>

                <template #cell(afterAdjusted)="data">
                  {{
                    [0, "0", ""].includes(data.item.adjusted)
                      ? formatNumber(data.item.quantity)
                      : ["NOTFOUND", "LOST", "BROKEN"].includes(data.item.reasonKey)
                      ? `${formatNumber(data.item.quantity)} - ${
                          data.item.adjusted
                        } = ${formatNumber(
                          checkNumReplaceComma(data.item.quantity) -
                            checkNumReplaceComma(data.item.adjusted)
                        )}`
                      : ["RETURN", "ADD"].includes(data.item.reasonKey)
                      ? `${formatNumber(data.item.quantity)} + ${
                          data.item.adjusted
                        } = ${formatNumber(
                          checkNumReplaceComma(data.item.quantity) +
                            checkNumReplaceComma(data.item.adjusted)
                        )}`
                      : ["RECOUNT"].includes(data.item.reasonKey)
                      ? `${data.item.adjusted}`
                      : `${formatNumber(data.item.quantity)}`
                  }}

                </template>

                <template #cell(unit)>
                  {{ Item.unit.name }}
                </template>
              </b-table>
            </div>
          </LayoutCard>
        </b-form>
      </ValidationObserver>

      <ItemArrangeColumn
        v-model="listFields"
        @value="
           fieldsInventory = $event
        "
      />

      <LayoutPopup id="Ton-kho-khong-hop-le" size="small">
        <template #title>Điều chỉnh tồn kho</template>
        <template #content>
          Các phiên bản sản phẩm có số lượng tồn kho kho khởi tạo âm. Vui lòng
          nhập lại số lượng
        </template>
        <template #control-right>
          <BaseButton size="sm" @click="editInventory()">
            Cập nhật tồn kho
          </BaseButton>
        </template>
      </LayoutPopup>

      <LayoutPopup id="Dieu-chinh-ton-kho" size="small">
        <template #title>Bạn chưa lưu chỉnh sửa</template>
        <template #content>
          Mọi thông tin chỉnh sửa tồn kho của chi nhánh sẽ được lưu lại. Bạn
          chắc muốn chuyển chi nhánh?
        </template>
        <template #control-right>
          <BaseButton
            size="sm"
            variant="secondary"
            @click="hidePopup('Dieu-chinh-ton-kho')"
          >
            Đóng
          </BaseButton>
          <BaseButton size="sm" @click="changeLocation">
            Tiếp tục chuyển
          </BaseButton>
        </template>
      </LayoutPopup>


      <div class="box-loading" v-if="loading">
        <div class="loading">
          <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
      </div>
      
      <b-modal
        v-model="popupEnableInventory"
        hide-header
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        centered
        title="Cập nhật tính năng kho"
        id="bv-modal-enable-inventory">
        <div class="box-modals">
          <div class="text-head-modal text-bold">Quản lý kho và Tồn kho</div>
          <div class="mt-3 text-center">
          <img src="/assets/warehousew.png" width="100">
          </div>
          <div class="text-head-active mt-1">Cửa hàng của bạn chưa kích hoạt tính năng <b>Quản lý kho</b> và <b>Tồn kho</b></div>
          <div class="text-des-active mt-3">Bên cạnh việc quản lý các hoạt động bán hàng, quản lý kho là một chức năng quan trọng. NextShop hỗ trợ kiểm soát hàng tồn kho nhanh chóng, nghiệp vụ xuất/nhập/chuyển kho chính xác, giảm thiểu tỉ lệ thất thoát đến 30%.</div>
          <div class="mt-3 line-active text-right">
          <span class="text-primary cursor btn-closed" @click="(popupEnableInventory=false, activeTab=0)">Đóng</span>
          <b-button variant="primary" size="md" class="btn btn-md btn-primary" v-if="isUpload"><i class="fas fa-spinner fa-spin"></i> Đang xử lý</b-button>
          <span class="btn btn-md btn-primary" v-if="!isUpload" @click="clickEnableInventory">Kích hoạt ngay</span>
          </div>
        </div>
    </b-modal>
		<b-modal
			v-model="popupEnableInventorySuccess"
			hide-header
			hide-footer
			no-close-on-backdrop
			centered
			title="Cập nhật tính năng kho"
			id="bv-modal-enable-inventory-success">
      <div class="box-modals">
        <div class="text-head-modal text-bold">Kích hoạt kho hàng thành công!</div>
        <div class="mt-3 text-center">
        <img src="/assets/store.png" width="100">
        </div>
        <div class="text-des-active mt-3">Từ giờ bạn đã có thể thêm sản phẩm bằng cách <b>Nhập kho, Kiểm hàng trong kho</b>, và nhiều tính năng khác!</div>
        <div class="mt-3 line-active text-right">
        <div class="ext-primary cursor btn-closed" @click="clickHideInventorySuccess">Đóng</div>
        </div>
      </div>
		</b-modal>
    </div>
    <NotPermission v-else></NotPermission>
  </Layout>
</template>

<script>
import Swal from "sweetalert2";
import Layout from "@/router/layouts/item";
import ItemArrangeColumn from "@/pages/items/components/ItemArrangeColumn.vue";
import ChangeQuantity from '@/pages/inventory/components/change-quantity.vue'

import formatNumber from "@/mixins/items/formatNumber";
import getListInventory from "@/mixins/items/getListInventory";
import getListLocation from "@/mixins/items/getListLocation";
//import getDetailItem from "@/mixins/items/getDetailItem";
import getDetailItemCompound from "@/mixins/items/getDetailItem";
import handlerReqInventory from "@/mixins/items/handlerReqInventory";
import genBarcode from "@/mixins/items/handleBarcode"
import { ItemService } from "@/services/nextshop/item.service";
import { getCurrentMerchant, getDataPermission, getLocationID, getRuleUser } from '../../utils/auth';
import { inventoryItem, inventoryItemLoHsd } from '@/utils/fieldsTable.js'
import { reasons } from '../../utils/mapping';
import PopupSetValue from '@/components/popup-add-quick/popup-set-value';

import { categoryGetList } from '@/api/category';
import { SettingService } from "@/services/nextshop/setting.service"

export default {
  components: {
    Layout,
    ItemArrangeColumn,
    ChangeQuantity,
    PopupSetValue
  },

  mixins: [
    getListInventory,
    getListLocation,
    //getDetailItem,
    getDetailItemCompound,
    formatNumber,
    handlerReqInventory,
    genBarcode,
  ],

  data() {
    return {
      checkboxAll: false,
      updateUI: 1,
      dataPermission: getDataPermission(),
      submit: false,
      showTableVariations: false,
      showTableVariationsTmp: false,
      loading: false,
      isPopupAddUnit: false,
      importPrice: '',
      exportPrice: '',
      selectedBox: [],
      inventoryId: "",
      inventoryName: "",
      locationIdTmp: "",
      locationId: getLocationID(),
      locationNameTmp: "",
      locationName: this.getNameLocation(getLocationID()),
      roleUser: getRuleUser(),
      fieldsInventory: inventoryItem,
      dataInventory: [],
      dataLocations: [],
      optionsItem: [
        {
          name: "",
          values: [""],
        },
      ],
      listFields: [],
      listReason: [],
      Item: {
        name: "",
        unit: "",
        weightInGram: 0,
        categoryId: "",
        metaSearchable: {
          brand: "",
          isSelling: false,
          category: "",
          statusDefault: false,
          statusImei: false,
          statusBatch: false
        },
        validate: {
          sku: "",
          upc: "",
        },
        description: "",
        images: [],
        options: [],
        sku: "",
        upc: "",
        tags: [],
        unit: {
          name: "",
          additionalUnits: [],
        },
        variations: [],
        selected: false,
        priceItem: [
          {
            exportPrice: 0,
            importPrice: 0,
          },
        ],
        warranty: {
          description: "",
          dueAtInMinute: "3021-01-26T20:14:52.036Z",
          duration: 0,
          timeUnit: "",
          warrantyName: "",
        },
      },
      lineItemReqsTmp: [],
      Inventory: {
        lineItemReqs: [
          {
            name: "",
            sku: "",
            unit: "",
            quantity: 0,
            edit: "",
            reason: "",
            reasonKey: "",
            adjusted: 0,
            afterAdjusted: 0,
          },
        ],
      },
      existedUpc: [],
      inforMerchant: getCurrentMerchant(),
      dataItems: [],
      popupEnableInventory: false,
			popupEnableInventorySuccess: false,
			isUpload: false,
			coMerchantId: JSON.parse(localStorage.getItem("auth.currentMerchant")).id,
      check:false,
      useProductBatch: true
    };
  },

  async created() {
    try {
      this.loading = true;

      this.listReason = reasons.map(reason => {
        return {
          ...reason,
          key: reason.value
        }
      })
      this.getCategorys()
      this.dataLocations = await this.getListLocation(this.roleUser);
      await this.checkConfigInventoryTab()

      let listInventory = await this.getListInventory(
        this.Inventory.locationId
      );
      
      let inventoryDefault = listInventory.find((e) => e.isDefault === true);
      if(inventoryDefault && inventoryDefault.coInventoryId !== ''){
        this.dataInventory.push(inventoryDefault);
        this.inventoryId = inventoryDefault.coInventoryId;
        this.inventoryName = inventoryDefault.name;
      }
      
      await this.getDataItem();

      // check type item: set fields show
      if(this.Item.metaSearchable.statusBatch){
        this.fieldsInventory = inventoryItemLoHsd
      }else{
        this.fieldsInventory = inventoryItem
      }

      this.loading = false;
    } catch (error) {
      console.log(error);
    }
  },
  computed: {
    itemUseImeiAndSerial() {
      return this.Item.metaSearchable.useImeiAndSerial !== 'true'
    },
    allowDisplayQuickActionInventory() {
      return this.selectedBox.length > 0 && this.Item.metaSearchable.useImeiAndSerial !== 'true'
    },
  },
  methods: {
    getCategorys() {
      const req = {
        queryString: { parentId: { eq: "" } },
        sort: "-id",
        lastItem: "",
        limit: 100,
      }
      categoryGetList(req).then(res => {
        this.dataCategory = res.data
      })
    },
    checkItem(obj) {
      const checkExist = this.selectedBox.findIndex(select => select.itemVariationId === obj.itemVariationId)
      if (checkExist === -1) {
        this.selectedBox.concat(obj)
      }
      if ( this.activeTab === 0 ? this.selectedBox.length === this.Item.variations.length : this.selectedBox.length === this.Inventory.lineItemReqs) {
        this.checkboxAll = true
        this.selectAll()
      } else {
        this.checkboxAll = false
      }
    },
    selectAll() {
      if (this.checkboxAll) {
        this.selectedBox = this.Inventory.lineItemReqs
      } else {
        this.selectedBox = []
      }
    },
    onResult(obj) {  
        this.Inventory.lineItemReqs.forEach(varia => {
          const checkExist = this.selectedBox.find(select => select.variationId === varia.variationId)
          if (checkExist) {
            if (obj.type === 'changeQuantity') {
              varia.reason = 'Đếm lại'
              varia.reasonKey = 'RECOUNT'
              varia.typeChange = 'RECOUNT'
              varia.adjusted = obj.value
            }
          }
        })
      this.updateUI += 1
    },

    editInventory() {
      this.hidePopup("Ton-kho-khong-hop-le");
    },

    async changeLocation() {
      this.loading = true;

      this.hidePopup("Dieu-chinh-ton-kho");
      this.dataInventory = [];
      this.locationId = this.locationIdTmp;
      this.locationName = this.locationNameTmp;

      let listInventory = await this.getListInventory(this.locationIdTmp);
      let inventoryDefault = listInventory.find((e) => e.isDefault === true);
      if(inventoryDefault && inventoryDefault.coInventoryId !== ''){
        this.dataInventory.push(inventoryDefault);
        this.inventoryId = inventoryDefault.coInventoryId;
        this.inventoryName = inventoryDefault.name;
      }
      await this.updateItem("change_location");
    },

    validateInventory() {
      this.Inventory.lineItemReqs = this.Inventory.lineItemReqs.map((e) => {
        return {
          ...e,
          validate:
            ["NOTFOUND", "LOST", "BROKEN"].includes(e.reasonKey) &&
            this.checkNumReplaceComma(e.adjusted) > e.quantity
              ? "Số lượng nhập phải nhỏ hơn số lượng tồn"
              : "",
        };
      });
      const arrInventoryError = this.Inventory.lineItemReqs.filter(
        (e) => e.validate != ""
      );
      return arrInventoryError.length > 0 ? true : false;
    },

    async getValueLocationName($event) {
      if ($event.coLocationId != this.locationId) {
        this.locationIdTmp = $event.coLocationId;
        this.locationNameTmp = $event.text;
        this.showPopup("Dieu-chinh-ton-kho");
      }
    },

    handlerDataInventory(responseItem) {
      
      console.log(responseItem)

      this.Inventory.locationId = this.locationId;
      this.Inventory.inventoryId = this.inventoryId;

      const result = this.handlerReqInventory(this.Item, this.Inventory);
      return {
        ...result,
        unit: this.Item.unit.name === "" ? "Cái" : this.Item.unit.name,
        inventoryId: this.inventoryId,
        lineItemReqs: result.lineItemReqs.map((e) => {
          return {
            ...e,
            typeChange: e.reasonKey,
            reason: e.reason,
            quantityCurrent: e.quantity,
            quantityChange: e.adjusted,
            quantityAfterChange: e.afterAdjusted,
            discount: [],
            addedAmount: result.lineItemReqs.map((e) => {
              return {
                reason: e.reason,
                amount: e.adjusted,
              };
            }),
          };
        }),
      };
    },

    async getDataItem() {
      try {
        //const response = await this.getDetailItem(this.$route.params.id);
        const params = {itemId: this.$route.params.id }
        const response = await this.getDetailItemCompound(params);

        let useBatch = response?.metaSearchable.useProductBatch === "true"
        if (response) {
          this.Item = {
            ...response,
            variations: response.variations.map(vari => {
              return {
                ...vari,
                variations: response.variations
              }
            })
          }
        }

        console.log(this.Item.variations)

        this.optionsItem =
          this.Item.options.length > 0
            ? this.Item.options.map((e) => {
                return {
                  ...e,
                  disabled: false,
                };
              })
            : this.optionsItem;

        const inventoryTmp = this.Item.variations.map((e, index) => {
          let result = "";
          if (e.stockQuantities[0]) {
            result = e.stockQuantities[0].inventoryDatas.find(
              (e) => e.inventoryId === this.inventoryId
            );
          }
          let stockQuantities = e.stockQuantities.find(stockQuantitie => stockQuantitie.type === "NSH_ITEM_SALE")
          let inventoryDatas = stockQuantities ? stockQuantities.inventoryDatas.filter(inventoryData => inventoryData.inventoryId === this.inventoryId) : []
          let quantityInven = inventoryDatas.reduce((a, b) => {
            return a + b.quantity
          }, 0)
          return {
            ...e,
            key: index + 1,
            name: e.name,
            sku: e.sku,
            unit: result != undefined && result != "" ? result.unit : "Cái",
            quantity: result != undefined && result != "" ? result.quantity : 0,
            inventoryId:
              result != undefined && result != ""
                ? result.inventoryId
                : this.inventoryId,
            edit: "",
            reason: "Nhập kho",
            reasonKey: "ADD",
            validate: "",
            adjusted: 0,
            afterAdjusted: 0,
            // add for cpn change-quantity
            itemInstance: {
              name: e.name,
              unit: result != undefined && result != "" ? result.unit : "Cái",
            },
            checkInAt: new Date(Date.now()).toISOString(),
            useImeiAndSerial: this.Item.metaSearchable.statusImei,
            useProductBatch: useBatch,
            price: 0,
            meta: {
              category: this.Item.category,
              name: e.name,
              useImeiAndSerial: this.Item.metaSearchable.statusImei,
              useProductBatch: useBatch
            },
            quantity: quantityInven
          };
        })
        this.Inventory.lineItemReqs = inventoryTmp;
        this.lineItemReqsTmp = inventoryTmp.map(e => e)

        this.showTableVariationsTmp =
          this.Item.options.length;
        this.showTableVariations = this.Item.options.length > 0;

        this.listFields =
            this.fieldsInventory
            
        this.Item.metaSearchable.statusBatch = useBatch
        if (useBatch) {
          this.Item.metaSearchable.statusDefault = false
          this.Item.metaSearchable.statusImei = false
        }
      } catch (error) {
        console.log(error);
      }
    },

    async updateItem(key) {
      this.loading = true;
     
      const paramInventory = await this.handlerDataInventory(this.Item);
      const responseInventory = await ItemService.editInventory(paramInventory);
      
      if (responseInventory.code === 'CURRENT_QUANTITY_NOT_MATCHED' || responseInventory.success) {
          if (key === "change_location") {
            // case chọn đổi chi nhánh khac
            await this.getDataItem();
            this.loading = false;
          } else {
            // case chọn submit trên header
            this.loading = false;

            Swal.fire({
              icon: "success",
              title: 'Thành công',
              text: 'Cập nhật sản phẩm thành công',
              confirmButtonText: "Xác nhận",
            }).then(() => {
              this.$router.push(`/items/items-detail/${this.$route.params.id}`);
            });
          }
      }else{
        if(responseInventory.success === false){
          Swal.fire({
            icon: "error",
            title: 'Thất bại',
            text: responseInventory.message,
            confirmButtonText: "Xác nhận",
            }).then(() => {
            this.loading = false
          });
        }
      }
      this.loading = false
    },

    checkBarcode() {
      this.existedUpc  = this.selectedBox.filter((e) => (e.upc != ""))
      if (this.existedUpc.length != 0) {
        this.showPopup("check-barcode")
      } else {
        this.selectedBox.map((e,index) => {
          if (e.upc === "") {
            this.generateBarcode(index)
          }
        })
      }
    },

    async generateBarcode(index) {
      try {
        const resBarcode = await this.genBarcode(1)
        if (!this.showTableVariations) {
          this.Item.upc = resBarcode
        } else {
          this.Item.variations[index].upc = resBarcode
        }

        if (this.selectedBox.length > 0) {
          this.existedUpc.push(this.Item.variations[index])
        }
      } catch (error) {
        console.log(error);
      }
    },


    clickBarcodeChooseMore () {
      if(this.selectedBox.length > 0){
        this.selectedBox.map((item) => {
          let oneItem = {
            "amount": this.checkNumReplaceComma(item.prices.exportPrice),
            "images": item.images,
            "itemVariationId": item.itemVariationId,
            "lineItemId": (this.$route.params.id) ? this.$route.params.id : Math.random()*100,
            "mcName": this.inforMerchant.name,
            "name": item.nameOption,
            "quantity": 0,
            "sku": item.sku,
            "unitPrice": this.checkNumReplaceComma(item.prices.exportPrice),
            "upc": item.upc
          }
          const index = this.Inventory.lineItemReqs.length > 0 ? this.Inventory.lineItemReqs.findIndex((e) => e.itemVariationId === item.itemVariationId) : -1
          if(index != -1){
            if([0, "0", ""].includes(this.Inventory.lineItemReqs[index].adjusted)){
              oneItem.quantity = this.checkNumReplaceComma(this.Inventory.lineItemReqs[index].quantity)
            }else{
              if(["NOTFOUND", "LOST", "BROKEN"].includes(this.Inventory.lineItemReqs[index].reasonKey)){
                oneItem.quantity = this.checkNumReplaceComma(this.Inventory.lineItemReqs[index].quantity) - this.checkNumReplaceComma(this.Inventory.lineItemReqs[index].adjusted)
              }
              if(["RETURN", "ADD"].includes(this.Inventory.lineItemReqs[index].reasonKey)){
                oneItem.quantity = this.checkNumReplaceComma(this.Inventory.lineItemReqs[index].quantity) + this.checkNumReplaceComma(this.Inventory.lineItemReqs[index].adjusted)
              }
              if(["RECOUNT"].includes(this.Inventory.lineItemReqs[index].reasonKey)){
                oneItem.quantity = this.checkNumReplaceComma(this.Inventory.lineItemReqs[index].adjusted)
              }
            }
            this.sleep(1000)
          }
          this.dataItems.push(oneItem)
        })
        this.saveStorage()
        this.$router.push({ path: '/barcode/choose' })
      }
    },
    saveStorage () {
      localStorage.setItem('itemBarcode', JSON.stringify(this.dataItems))
    },
    async checkConfigInventoryTab(){
			const response = await SettingService.getDataMerchant();
			let enableInventory = false
			if(response.success){
				enableInventory = response.data.merchant.enableInventory
			}
			if(!enableInventory){
				this.popupEnableInventory = true
        this.check=false
			}else{
        this.check=true
      }
		},
		async clickEnableInventory(){
			const params = {
				"coMerchantId": this.coMerchantId,
				"enableInventory": true
			}
			this.isUpload = true
			const response = await SettingService.enableInventory(params);
			if(response.success){
				this.popupEnableInventory = false
				this.popupEnableInventorySuccess = true
				this.isUpload = false
			}
		},
		async clickHideInventorySuccess(){
			this.popupEnableInventorySuccess = false
		},
  },

  watch: {
    submit() {
      this.updateItem()
    }
  },
};
</script>

<style lang="scss" scoped>
.box-dashed {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 14px;
  font-weight: 500;
  font-size: 14px;
  border: 1px dashed #9eb4fa;
  border-radius: 4px;
  background-color: #fff;
  color: #3e69f6;
  cursor: pointer;
  i {
    padding-right: 5px;
  }
}


.isSelling {
  display: flex;
  align-items: center;
  height: 100%;

  & > *:not(*:first-child) {
    margin-left: 10px;
  }
}

.field_check_box {
  display: flex;
  align-self: center;

  .check_box {
    display: flex;
    margin-right: 30px;
  }
}

::v-deep .upc-input {
  .__wrap {
    width: 224px;

    .__input {
      text-transform: uppercase;
    }
  }
}
.text-head-modal{
    color: #000;
    font-size: 15px;
    line-height: 20px;
    text-align: left;
    background: #f0f0f0;
    padding: 8px 10px;
  }
  .text-head-active{
    text-align: center;
    width: 90%;
    margin: 0 auto;
  }
  .text-des-active{
    text-align: center;
    width: 90%;
    margin: 0 auto;
  }
  .box-modals .btn {
    margin: 0 5px;
  }
  .line-active{
    border-top: 1px solid #ddd;
    padding-top: 12px;
  }
  .btn-closed{
    padding:10px 15px;
  }
  .arrTabs{
    display:inline-block;
    width: 100%;
  }
  .arrTabs li{
    display:inline-block;
    font-weight: bold;
    font-size: 20px;
    color: #a7acb1;
    cursor: pointer;
  }
  .arrTabs li.active{
    color: #23313E;
  }
  .card_wall{
    border-left: 2px solid #B9B9B9;
    margin: 0px 20px;
    display: inline-block;
    height: 22px;
    position: relative;
    top: 5px;
  }
</style>
